import * as React from "react";
import { BaseComponent } from "../../../../react-core/Html/BaseComponent";
import { ButtonLabels } from "../../../Dashboard/Components/Clients/AddClient/Resource/Contents";

export interface IProcessNavigateBtnState {}

export interface IProcessNaviBtnConfig {
    title: string | JSX.Element;
    onClick: VoidFunction;
}

export interface IProcessNavigateCustomBtnProps {
    primary?: IProcessNaviBtnConfig;
    secondary?: IProcessNaviBtnConfig;
    needPrint?: boolean;
    isBusy?: boolean;
}

export class ProcessNavigateCustomBtn extends BaseComponent<IProcessNavigateCustomBtnProps, {}> {
    constructor(props: any) {
        super(props);
    }

    public render(): JSX.Element {
        const { primary, secondary, isBusy, needPrint } = this.props;

        return (
            <div className="page-actions no-print">
                {primary && (
                    <div className="action-primary">
                        <button
                            onClick={() => (isBusy ? null : primary.onClick())}
                            className={`next-button ${isBusy ? "btn is-busy" : ""}`}
                        >
                            <span aria-hidden="true" className="icon"></span>
                            <span className="text">{primary.title}</span>
                        </button>
                    </div>
                )}

                {secondary && (
                    <div className="action-secondary">
                        <button
                            onClick={() => (isBusy ? null : secondary.onClick())}
                            className={`prev-button ${isBusy ? "btn is-busy" : ""}`}
                        >
                            <span aria-hidden="true" className="icon"></span>
                            <span className="text">{secondary.title}</span>
                        </button>
                    </div>
                )}
                {needPrint && (
                    <div className="action-secondary">
                        <button
                            onClick={() => {
                                window.print();
                            }}
                            className="print-button"
                        >
                            <span aria-hidden="false" className="print-icon"></span>
                            {ButtonLabels.printReview}
                        </button>
                    </div>
                )}
            </div>
        );
    }
}
